const LABELS = {
  open: "Aperta",
  aperto: "Aperta",
  aperta: "Aperta",
  pending: "In attesa",
  in_attesa: "In attesa",
  assigned: "Professionista scelto",
  professionista_scelto: "Professionista scelto",
  in_progress: "In corso",
  in_corso: "In corso",
  in_viaggio: "In viaggio",
  arrivato: "Arrivato",
  iniziato: "Iniziato",
  completed: "Completato",
  completato: "Completato",
  risolto: "Risolto",
  cancelled: "Annullata",
  canceled: "Annullata",
  annullato: "Annullata",
  closed: "Chiusa",
  accettata: "Accettata",
  accepted: "Accettata",
  rifiutata: "Rifiutata",
  rejected: "Rifiutata",
  domande: "Chiarimento richiesto",
  needs_clarification: "Chiarimento richiesto",
};

export const statusLabel = (status) => LABELS[status] || String(status || "").replace(/_/g, " ");

export const TERMINAL_STATUSES = ["risolto", "completed", "completato", "cancelled", "canceled", "annullato", "closed"];
export const ASSIGNED_STATUSES = ["professionista_scelto", "assigned"];

export const isTerminalStatus = (s) => TERMINAL_STATUSES.includes(s);
